    <!-- 
    <div class="login-page">
    <div class="form">
      <div *ngIf ="messageSuccess">
        <form [formGroup]="confirmLogin" class="login-form">
          <input type="text" formControlName ="UserName" placeholder="User Name"/>
          <input type="password"formControlName ="Password" placeholder="Password" (keydown)="onKeydown($event)"/>
        
        
        </form>
      
      </div>
      
      <div *ngIf ="!messageSuccess">
        <div class="alert alert-success" role="alert">
          <h4 class="alert-heading"> Hi User !</h4>
        
          <hr>
          <p class="mb-0">Let Me Check  your Login Detail</p>
        </div>
      
      </div>
    <div style="text-align: right;">
      <a  routerLink="/delete"><i  class="fas fa-fw fa-folder"></i></a>
    </div>
      
      
    </div>
    

    </div> -->
    <div class="current-time">
  {{ currentTime | date:'hh:mm:ss a' }}
</div>
   
<div class="login-container">
  <h2 [routerLink]="['/permission/logout']" style="cursor: pointer;">Welcome Team</h2>
  <form [formGroup]="confirmLogin" >
    <div class="input-field">
      <input type="text" formControlName="userName" placeholder="Username" />
    </div>
    <div class="input-field">
      <input type="password" formControlName="password" placeholder="Password"  (keydown)="onKeydown($event)"/>
    </div>
    <button type="submit" (click)="onSubmit()"> LOGIN</button>
  </form>
  <!-- <div class="footer">
    Don't have an account? <a routerLink="/register">Register</a>
  </div> -->
</div>




     <!-- <div *ngIf="showWrongPassword" class="button-container">
      <div class="overlay" *ngIf="alredyExitMesssgae">
        <h3 class="error-text">Already Login</h3>
      </div>

      <video width="640" height="360" autoplay muted loop playsinline>
        <source src="assets/videos/3.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div> -->
 





<!--  
    <div class="card glass-login-card" >
  <div class="banner" (click)="nevigateToLogot()">
    <span class="banner-text">Please Login</span>
    <span class="banner-text">JOIN US</span>
  </div>

  <span class="card__title">Good Day</span>
  <p class="card__subtitle">“Do The Things That Matter”</p>

  <form [formGroup]="confirmLogin" class="card__form">
    <div class="input-wrapper">
      <input type="text" placeholder="User Name" formControlName="UserName" />
    </div>
    <div class="input-wrapper">
      <input type="password" placeholder="Password" formControlName="Password" (keydown)="onKeydown($event)" />
    </div>
  </form>
</div>



    <div class="🤚" *ngIf="!messageSuccess">
      <div class="👉"></div>
      <div class="👉"></div>
      <div class="👉"></div>
      <div class="👉"></div>
      <div class="🌴"></div>
      <div class="👍"></div>
    </div>






    <div *ngIf="showWrongPassword" class="button-container">
      <div class="overlay" *ngIf="alredyExitMesssgae">
        <h3 class="error-text">Already Login</h3>
      </div>

      <video width="640" height="360" autoplay muted loop playsinline>
        <source src="assets/videos/3.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>

    <div *ngIf="loginDone">
      <div class="button-container">
        <img src="assets/videos/1.png" class="animated-image" alt="My Photo" />
      <video width="640" height="360" autoplay muted loop playsinline>
        <source src="assets/videos/done1.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>
      </div>
    </div> -->







      
    
    <!-- From Uiverse.io by Pradeepsaranbishnoi --> 
      

      
